export default __webpack_public_path__ + "7ad3695e9e0301e7de3d1d1c0cf312a3.woff";